import { useSyncExternalStore } from 'react';

const subscribe = (callback: () => void) => {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
};

const getSnapshot = () => navigator.onLine;

export const useNetworkStatus = (): { isOnline: boolean } => {
  const isOnline = useSyncExternalStore(subscribe, getSnapshot);
  return { isOnline };
};
